import React from 'react';
import { useTranslation } from 'react-i18next';
import { GENDERS } from 'shared/constants';
import { REGISTRATION_TYPES } from 'shared/constants';

const ExamineeDetails = ({ examinee, nowManagedFlag }) => {
  const { t } = useTranslation();
  if (!nowManagedFlag) {
    return (
      <div className="columns-section dark-gray">
        {examinee.capacityType === REGISTRATION_TYPES.sectionRetest && (
          <div>
            <div>{t('rosters.retestLabel')}</div>
            <div>{examinee.sectionList}</div>
          </div>
        )}
        <div>
          <div>{t('common.labels.gender')}</div>
          <div>{GENDERS[examinee.gender]}</div>
        </div>
        <div>
          <div>{t('rosters.tableHeaders.hsCode')}</div>
          <div>{examinee.highSchoolCode}</div>
        </div>
        <div>
          <div>{t('rosters.tableHeaders.matchID')} </div>
          <div>{examinee.matchId}</div>
        </div>
        <div>
          <div>
            {t('common.labels.city')}
            <span className="text-lowercase">, {t('common.labels.state')}</span>
          </div>
          <div>
            {examinee.city}, {examinee.state}
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="columns-section dark-gray">
      {examinee.capacityType === REGISTRATION_TYPES.sectionRetest && (
        <div>
          <div>{t('rosters.retestLabel')}</div>
          <div>{examinee.sectionList}</div>
        </div>
      )}
      <div>
        <div>{t('common.labels.gender')}</div>
        <div>{GENDERS[examinee.gender]}</div>
      </div>
      <div>
        <div>{t('rosters.tableHeaders.stateStudentId')}</div>
        <div>{examinee.externalStudentId}</div>
      </div>
    </div>
  );
};

export default ExamineeDetails;
